
import { Hero } from './hero';
import { Newsletter } from './newsletter'
import { Features } from './features'
import { Footer } from './footer'
import { Pricing } from './pricing'
import { Navbar } from './navbar'
import { Onboard } from './onboard'
import { OnboardNew } from './onboard-new'
import { OnboardNewChoice } from './onboard-new-choice'
import { OnboardEnterprise } from './onboard-enterprise'
import { Filters } from './filters'
import { CustomHead } from './custom-head'

export { Hero, Newsletter, Features, Footer, Pricing, Navbar, Onboard, Filters, CustomHead, OnboardNew, OnboardNewChoice, OnboardEnterprise }